/** This plugins changed the ordinal axis for the selected range
 * and tries to keep a rangeselecor button selected
 * **/

const oneDay = 1000 * 60 * 60 * 24

function getX(point) {
  if (!point) {
    return null
  }
  //TODO util
  if (Array.isArray(point)) {
    return point.length > 0 ? point[0] : null
  }
  return point.x || 0
}

function isValidButton(index) {
  return index >= 0
}

export default function (H) {

  H.addEvent(H.Chart, 'beforeChange', function ({target: chart}) {
    const rangeSelector = chart.rangeSelector
    if (rangeSelector) {
      const selected = rangeSelector.selected
      if (isValidButton(selected)) {
        chart.preSelect = selected
      }
    }

  })

  H.addEvent(H.Chart, 'afterChange', function ({target: chart}) {
    //TODO simplify this and make it more robust
    const rangeSelector = chart.rangeSelector
    if (!rangeSelector) {
      return
    }

    if (rangeSelector.buttons[rangeSelector.selected]?.textStr === 'MAX') {
      const startPointVal = getX(chart.series[0].userOptions.data[0])
      const axisVal = chart.xAxis[0].getExtremes().min
      if (startPointVal - axisVal > oneDay * 5) {
        rangeSelector.clickButton(rangeSelector.selected)
      }
    } else if (rangeSelector?.rendered && isNaN(rangeSelector.selected)) {
      const userOptions = chart.userOptions
      const opts = userOptions.rangeSelector
      let nextBtn = !isValidButton(opts.selected) ? opts.selected : chart.preSelect
      if (!isValidButton(nextBtn) && opts.initSelection && rangeSelector.buttons[opts.initSelection].state !== 3) {
        nextBtn = opts.initSelection
      }
      if (!isValidButton(nextBtn)) {
        nextBtn = rangeSelector.buttons.findIndex(btn => btn.state !== 3)
      }
      if (nextBtn >= 0) {
        rangeSelector.clickButton(nextBtn)
      }
    } else if (rangeSelector.buttons[rangeSelector.selected].state === 3) {
      const nextBtn = rangeSelector.buttons.findIndex(btn => btn.state !== 3)
      if (nextBtn >= 0) {
        rangeSelector.clickButton(nextBtn)
      }
    }
  })
}
